import { Http } from '@/lib/http';

export class FlaggedAttemptService extends Http {
  constructor() {
    super();
    this.endpoint = '/aml-pro/app/flagged-attempts';
  }

  fetchAll(params = {}) {
    return this.httpClient().get(this.endpoint, { params });
  }

  fetchOne(id) {
    return this.httpClient().get(`${this.endpoint}/${id}`);
  }

  create(payload) {
    return this.httpClient().post(this.endpoint, payload);
  }

  update(id, payload) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, payload);
  }

  fetchByAccount(accountId) {
    return this.httpClient().get(`${this.endpoint}/account/${accountId}`);
  }
}